
import Vue from 'vue';
import { mapState } from 'vuex';
import ToastStore from './store';

const Toast =  {
    name: 'Toast',
    data() {
		return {};
	},
    computed: mapState({
        show: (state) => state.Toast.show,
        text: (state) => state.Toast.text,
        callback: (state) => state.Toast.callback,
        cancelState: (state) => state.Toast.cancelState
    }),
    created() {
        if (!this.$store.state.Toast) {
            this.$store.registerModule('Toast', ToastStore);
        }
    },
    methods: {
        cancel() {
            let {commit} = this.$store;
            if (this.cancelState) commit('Toast/cancel');
        }
    }
};

export default Toast;



// WEBPACK FOOTER //
// ./src/ui/toast/index.js